<div style="margin-left: 20px;">
    <form [formGroup]="SettingsForm">
        <div class="form-group row">
            <fieldset>
                <legend>
                    <input type="checkbox" [formControl]="EnableExport" />
                    <span class="uv-checkbox-label">Enable Export</span>
                </legend>
            </fieldset>
        </div>
        <div class="form-group row" [ngClass]="{'uv-disabled':!ExportEnabled}">
            <div class="uv-row">
                <span class="col-lg-2">Do export from:</span>
                <select class="col-lg-3" [formControl]="ExportOrigin"
                        [ngClass]="{'show-error':SettingsForm.hasError('validExportOrigin'), 'uv-disabled':!EnableExportOrigin}">
                    <option value="agent">Agent</option>
                    <option value="server">Server</option>
                </select>
                <button [disabled]="!isLicenseValid" type="button" style="margin-left: 20px !important;" pButton icon="fa fa-file-o" iconPos="left"
                        label="Export Now (from server)" (click)="ExportNow()"></button>
                <button type="button" pButton label="Test Asset Panda Connection" [disabled]="!enableTestAssetPandaButton" title="Test/Verify AssetPanda connection credentials" style="margin-left: 20px !important;"
                        (click)="testAssetPandaConnect()"></button>
            </div>
        </div>
        <hr style="margin-top: 20px; margin-bottom: 20px;" />
        <div class="form-group row mb-3" [ngClass]="{'uv-disabled':!ExportEnabled}">
            <span class="col-lg-2">*Target Server API URL:</span>
            <input class="col-lg-3" type="text" pInputText [formControl]="TargetServerApiURL" />
        </div>
        <div class="form-group row mb-3" [ngClass]="{'uv-disabled':!ExportEnabled}">
            <span class="col-lg-2">*Target Server Username:</span>
            <input class="col-lg-3" type="text" pInputText [formControl]="TargetServerUsername" />
        </div>
        <div class="form-group row mb-3" [ngClass]="{'uv-disabled':!ExportEnabled}">
            <span class="col-lg-2">*Target Server Password:</span>
            <input class="col-lg-3" type="password" pInputText [formControl]="TargetServerPassword" (keydown)="onPasswordKeyDownHandler($event)"/>
        </div>
        <div class="form-group row" [ngClass]="{'uv-disabled':!ExportEnabled}">
            <fieldset>
                <legend>Export Settings</legend>
            </fieldset>
        </div>
        <hr style="margin-top: 20px; margin-bottom: 20px;" />
        <div class="form-group row mb-3" [ngClass]="{'uv-disabled':!ExportEnabled}">
            <span class="col-lg-2">Building Name:</span>
            <input class="col-lg-3" type="text" pInputText [formControl]="BuildingName" />
        </div>
        <div class="form-group row mb-3" [ngClass]="{'uv-disabled':!ExportEnabled}">
            <span class="col-lg-2">Room Name:</span>
            <input class="col-lg-3" type="text" pInputText [formControl]="RoomName" />
        </div>

        <div class="form-group row">
            <div style="margin-left: 50px; margin-top: 10px; margin-bottom: 10px;">
                <input type="checkbox" [formControl]="ExportDevices" [ngClass]="{'uv-disabled':!ExportEnabled}" />
                <span class="uv-checkbox-label" [ngClass]="{'uv-disabled':!ExportEnabled}">Export Devices</span>
            </div>
        </div>
        <div class="form-group row">
            <div style="margin-left: 50px; margin-top: 10px; margin-bottom: 10px;">
                <input type="checkbox" [formControl]="ExportConfigs" [ngClass]="{'uv-disabled':!ExportEnabled}" />
                <span class="uv-checkbox-label" [ngClass]="{'uv-disabled':!ExportEnabled}">Export Startup/Running Configs</span>
            </div>
        </div>

</form>
</div>
